import React from "react";
import { useForm } from "react-hook-form";
import { Button, Form, Modal } from "react-bootstrap";

import {
  VALIDATION_TYPES,
  googleSocialLinkConstants,
} from "../../../../views/admin-screens/constants";

const {
  UPDATE_GOOGLE_SOCIAL_LINK,
  MAX_GOOGLE_SOCIAL_LINK_LENGTH,
  GOOGLE_SOCIAL_LINK_LIMIT_ERROR,
} = googleSocialLinkConstants;

const UpdateGoogleSocialLinkModal = (props) => {
  const {
    data,
    show,
    spinner,
    onClose,
    animate,
    onConfirm,
    ModalSize,
    CancelButtonText,
    UpdateButtonText,
    SubmitButtonStyle,
    CancelButtonStyle,
    SubmitButtonVariant,
    SubmitButtonClasses,
    CancelButtonVariant,
    CancelButtonClasses,
  } = props;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: data });

  const onSubmit = (formData) => {
    onConfirm({ ...data, ...formData });
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      animation={animate}
      size={ModalSize}
      className="react-survey-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Update Store</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <Form.Group>
            <Form.Label className="mb-1">Store:</Form.Label>
            <Form.Control
              disabled
              type="text"
              name="name"
              {...register("name")}
              data-testid="name-field"
              className="user-fields font-14-px text-secondary mb-3"
            />
          </Form.Group>
          <Form.Group>
            <Form.Label className="mb-1">Google Social Link:</Form.Label>
            <Form.Control
              type="url"
              isInvalid={errors.googleSocialLink}
              name="googleSocialLink"
              data-testid="google-social-link-field"
              {...register("googleSocialLink", {
                maxLength: MAX_GOOGLE_SOCIAL_LINK_LENGTH,
              })}
              className="form-control user-fields font-14-px text-secondary"
              disabled={spinner(UPDATE_GOOGLE_SOCIAL_LINK)}
            />
            {errors.googleSocialLink?.type === VALIDATION_TYPES.MAX_LENGTH && (
              <Form.Text className="text-danger">
                {GOOGLE_SOCIAL_LINK_LIMIT_ERROR}
              </Form.Text>
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant={SubmitButtonVariant}
            className={SubmitButtonClasses}
            style={SubmitButtonStyle}
            type="submit"
          >
            {UpdateButtonText}
          </Button>
          <Button
            variant={CancelButtonVariant}
            className={CancelButtonClasses}
            style={CancelButtonStyle}
            onClick={onClose}
          >
            {CancelButtonText}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default UpdateGoogleSocialLinkModal;